import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SegmentClassificationModel } from "../../models/SegmentClassificationModel";
import SegmentClassificationService from "../../services/SegmentClassificationService";
import SegmentClassificationSlice from "../slices/SegmentClassificationSlice";
import { RootState } from "../store";

export const SegmentClassificationActions = SegmentClassificationSlice.actions;
export const fetchSegmentClassifications = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(
      SegmentClassificationActions.setIsSegmentClassificationsFetching(true)
    );
    const response: SegmentClassificationModel[] =
      await SegmentClassificationService.getAllSegmentClassifications();
    dispatch(SegmentClassificationActions.setSegmentClassifications(response));
    dispatch(
      SegmentClassificationActions.setIsSegmentClassificationsFetching(false)
    );
  };
};
export const fetchParticularSegmentClassification = (
  SegmentClassification_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: SegmentClassificationModel =
      await SegmentClassificationService.getParticularSegmentClassification(
        SegmentClassification_id
      );
    dispatch(
      SegmentClassificationActions.setParticularSegmentClassification(response)
    );
  };
};
